import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KNZUtilModule } from '@knz/util';

@NgModule({
  imports: [CommonModule, KNZUtilModule],
})
export class ZipModule {}
